import { render, staticRenderFns } from "./yjfkList.vue?vue&type=template&id=aae2db8a&scoped=true&"
import script from "./yjfkList.vue?vue&type=script&lang=js&"
export * from "./yjfkList.vue?vue&type=script&lang=js&"
import style0 from "./yjfkList.vue?vue&type=style&index=0&id=aae2db8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae2db8a",
  null
  
)

export default component.exports